import { createRequest } from '@/shared/api/create-request'
import { Api } from '@/shared/api/rest/types'

export const api: Api = {
    getMainData: data =>
        createRequest({
            url: 'qr',
            method: 'POST',
            data: {
                token: data,
            },
        }),
    sendBankClick: data =>
        createRequest({
            url: 'qr/click',
            method: 'POST',
            data,
        }),
    sendAppData: data =>
        createRequest({
            url: 'setup',
            method: 'POST',
            data,
            apiUrl: process.env.VUE_APP_NAMBA_METRICS_API_DOMAIN,
        }),
    sendAppEvent: data =>
        createRequest({
            url: 'event',
            method: 'POST',
            data,
            apiUrl: process.env.VUE_APP_NAMBA_METRICS_API_DOMAIN,
        }),
}
